import React from "react";
import { ReactComponent as SettingIcon } from "./../../../Icons/settings.svg";
import SelectComp from "../../../NewComponent/Select/Select";
import MultiSelectComp from "../../../NewComponent/MultiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action/index";
import { langArrFormatTwo } from "../../../utils";
import DoubleSelect from "../../../NewComponent/DoubleSelect/DoubleSelect";
export default function Settings() {
  const dispatch = useDispatch();
  const {
    briefSourceChange,
    briefLangChange,
    briefAgenticIsOpen,
    briefOutputChange,
    briefAgenticIsIframe,
  } = bindActionCreators(Actions, dispatch);
  const userState = useSelector((state) => state.user);
  const briefState = useSelector((state) => state.brief);
  const textStyles3 = {
    fontSize: "16px",
    color: "#5C667B",
    lineHeight: "32px",
    fontWeight: "300",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    marginTop: "15px",
    // width:'100%',
    // cursor:'pointer',
  };
  const funcCon = (arr) => {
    let newArr = [];
    arr.filter((ar) => {
      let obj = {
        value: ar,
        label: ar,
      };
      newArr.push(obj);
    });
    return newArr;
  };
  const onChnage = (ev) => {
    briefOutputChange(ev);
  };
  const onChangeSource = (ev) => {
    briefSourceChange(ev);
  };
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", paddingInline:'20px', gap:'20px',paddingBlock:'10px' }}>
        <div>
          <SelectComp
            isString={false}
            onChangeFunc={briefLangChange}
            width={'8vw'}
            size={'large'}
            val={briefState.lang}
            options={funcCon(userState.multipleLanguages)}
          />
        </div>
        <div>
          <SelectComp
            isString={false}
            onChangeFunc={onChnage}
            val={briefState.briefType}
             size={'large'}
            options={[
              { name: "text", label: "Text", value: "text" },
              { name: "Audio+Text", label: "Audio", value: "audio" },
            ]}
            width={'8vw'}
          />
        </div>
      </div>
    </>
  );
}
